<script setup lang="ts">
import type { StrapiBlockHeading } from '@nimbus/types'

const props = defineProps<StrapiBlockHeading>()
</script>

<template>
    <component
        :is="`h${props.level}`"
    >
        <NimbusStrapiBlockRenderer :content="children" />
    </component>
</template>
